import { z } from 'zod'
import { TIPO_ETAPA, type TipoEtapa } from '../enums'
import { textoObrigatorio } from './comum'

export const ROTULO_TIPO_ETAPA: Record<TipoEtapa, string> = {
  normal: 'Normal',
  ganho: 'Ganho',
  perda: 'Perda',
}

const corSchema = z
  .string()
  .trim()
  .regex(/^#[0-9a-fA-F]{6}$/, 'use uma cor no formato #RRGGBB')

export const criarFunilSchema = z.object({
  nome: textoObrigatorio('nome do funil', 80),
  ordem: z.number().int().min(0).default(0),
})
export type CriarFunilEntrada = z.infer<typeof criarFunilSchema>

export const atualizarFunilSchema = z.object({
  nome: textoObrigatorio('nome do funil', 80).optional(),
  ordem: z.number().int().min(0).optional(),
  ativo: z.boolean().optional(),
})

export const criarEtapaSchema = z.object({
  nome: textoObrigatorio('nome da etapa', 80),
  cor: corSchema.default('#94a3b8'),
  tipo: z.enum(TIPO_ETAPA).default('normal'),
})
export type CriarEtapaEntrada = z.infer<typeof criarEtapaSchema>

export const atualizarEtapaSchema = z.object({
  nome: textoObrigatorio('nome da etapa', 80).optional(),
  cor: corSchema.optional(),
  tipo: z.enum(TIPO_ETAPA).optional(),
})

/** Reordenação em bloco: a tela manda a lista inteira na ordem nova. */
export const reordenarEtapasSchema = z.object({
  etapaIds: z.array(z.string().uuid()).min(1),
})

export interface EtapaDto {
  id: string
  funilId: string
  nome: string
  ordem: number
  cor: string
  tipo: TipoEtapa
  /** Quantos cards estão parados nesta etapa agora. */
  contatos: number
}

export interface FunilDto {
  id: string
  nome: string
  ordem: number
  ativo: boolean
  etapas: EtapaDto[]
}
